import React from 'react'
import "./contact.css"
import ContactForm from '../../comp/contact/ContactForm'

const Contact = () => {
  return (
    <ContactForm />
  )
}

export default Contact